import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {number} */
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = /** @type {Refs} */ (this.refs);
    if (!dialog) return;

    // Refs do not cross nested `*-component` boundaries (e.g., `cart-items-component`), so we query within the dialog.
    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      // Ensure the dialog doesn't get stuck in "unsticky" mode when summary disappears (e.g., empty cart).
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
// ===== Minimum Order Check (500 EGP) =====
(function () {
  const MINIMUM = 50000; // Shopify بيحسب بالقروش (500 جنيه = 50000 قرش)

  function getCheckoutButton() {
    return document.querySelector('cart-drawer-component [name="checkout"], cart-drawer-component button[data-cart-checkout], cart-drawer-component .cart__checkout-button');
  }

  function getOrCreateNotice() {
    let notice = document.getElementById('cart-minimum-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'cart-minimum-notice';
      notice.dir = 'rtl';
      notice.style.cssText = `
        font-family: inherit;
        font-size: 14px;
        text-align: center;
        padding: 10px 16px;
        margin: 8px 0;
        border-radius: 8px;
        font-weight: 500;
      `;
      const checkoutBtn = getCheckoutButton();
      if (checkoutBtn) {
        checkoutBtn.parentNode.insertBefore(notice, checkoutBtn);
      }
    }
    return notice;
  }

  function updateMinimumCheck() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const total = cart.total_price;
        const checkoutBtn = getCheckoutButton();
        const notice = getOrCreateNotice();

        if (!checkoutBtn || !notice) return;

        if (total >= MINIMUM) {
          notice.textContent = 'يمكنك الآن إتمام الطلب ✓';
          notice.style.background = '#e8f5e9';
          notice.style.color = '#2e7d32';
          checkoutBtn.removeAttribute('disabled');
          checkoutBtn.style.opacity = '1';
          checkoutBtn.style.pointerEvents = 'auto';
        } else {
          const remaining = ((MINIMUM - total) / 100).toFixed(0);
          notice.textContent = `أضف منتجات بقيمة ${remaining} جنيه لإتمام الطلب`;
          notice.style.background = '#fdf3e7';
          notice.style.color = '#6B4C35';
          checkoutBtn.setAttribute('disabled', 'disabled');
          checkoutBtn.style.opacity = '0.5';
          checkoutBtn.style.pointerEvents = 'none';
        }
      });
  }

  // شغّل عند فتح الـ Drawer
  document.addEventListener(CartAddEvent.eventName, () => {
    setTimeout(updateMinimumCheck, 300);
  });

  document.addEventListener('dialog:open', () => {
    setTimeout(updateMinimumCheck, 300);
  });

  // شغّل عند أي تغيير في الكارت
  document.addEventListener('cart:updated', () => {
    setTimeout(updateMinimumCheck, 300);
  });

  // شغّل عند تحميل الصفحة
  document.addEventListener('DOMContentLoaded', updateMinimumCheck);
})();
// ===== End Minimum Order Check =====